export var TicketReplyType;
(function (TicketReplyType) {
    TicketReplyType[TicketReplyType["CUSTOMER"] = 0] = "CUSTOMER";
    TicketReplyType[TicketReplyType["TEAM_MEMBER"] = 1] = "TEAM_MEMBER";
})(TicketReplyType || (TicketReplyType = {}));
;
//# sourceMappingURL=reply-type.enum.js.map